



































































































































































import { Component, Vue } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import GerencialAssociadosInativosService from "@/service/relatorio/gerencial/GerencialAssociadosInativosService";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { PaginationModel } from "@/models/commons/PaginationModel";
import FiltroLeadFrotaDTO from "@/api/integracao-contabil/FiltroLeadFrotaDTO"
import ContabilOrcamentoFrotaService from "@/service/ContabilOrcamentoFrotaService";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog,
  },
})
export default class RelatorioFrotaLeds extends Vue {
  $refs!: {
    relatorioObserver: InstanceType<typeof ValidationObserver>;
  };


  lista = [];
  tableHeader = [
    { text: 'Nome', value: 'nome', width: '15%' },
    { text: 'Número', value: 'telefone', width: '15%'  },
    { text: 'E-mail', value: 'email', width: '15%'  },
    { text: 'Frota Própria', value: 'frotaPropria' },
    { text: 'Qtd. da Frota', value: 'quantidadeFrota'},
    { text: "Ação", value: "actions", width: "15%", sortable: false }
  ];

  detalhes(item:any){
    const id = item.id!.toString();
    this.$router.push({ name: 'ConsultarFrotaLeads', params: { idLeads: id } });
  }

  tableOptions: PaginationModel = {
    itemsPerPage: 5,
    page: 1,
    itemsLength: 1,
  };

  relatorio: FiltroLeadFrotaDTO = {
    dataInicio: undefined,
    dataFim: undefined,
  };

  showDialog = false;
  successDialog = false;
  dialogTitle = "";
  dialogMessage = "";
  loading = false;
  collapsibleOpened = false;

  getData() {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilOrcamentoFrotaService.consultarLeadFrota(this.relatorio)
          .then((res) => {
            console.log(res);
            this.loading = false;
            this.lista = res;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        //this.limparformulario();
      }
    });
  }

  public gerarRelatorio(tipo: string): void {
    this.$refs.relatorioObserver.validate().then((valid: boolean) => {
      if (valid) {
        this.loading = true;
        ContabilOrcamentoFrotaService.gerarRelatorioLeadsFrota(tipo, this.relatorio)
          .then((res) => {
            let fileURL = window.URL.createObjectURL(new Blob([res.data]));

            let fileLink = document.createElement("a");

            fileLink.href = fileURL;

            fileLink.setAttribute(
              "download",
              `leads_frota.${
                tipo.toLowerCase() === "excel" ? "xls" : "pdf"
              }`
            );

            document.body.appendChild(fileLink);

            fileLink.click();

            this.loading = false;
          })
          .catch((err) => {
            this.openDialog(false, "Erro", err.message);
            this.loading = false;
          });

        this.limparformulario();
      }
    });
  }

  public toggleCollapsible(): void {
    this.collapsibleOpened = !this.collapsibleOpened;
  }

  public limparformulario(): void {
    this.relatorio = {};
    this.$refs.relatorioObserver.reset();
  }

  private openDialog(success: boolean, title: string, message: string) {
    this.successDialog = success;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    this.showDialog = false;
  }

  get btnColor() {
    return this.successDialog ? "#00CD96" : "error";
  }

  get btnText() {
    return this.successDialog ? "Ok, entendi" : "Fechar";
  }

  get dialogImg() {
    return this.successDialog ? "success.png" : "error.png";
  }
}
